import clsx from "clsx"
import { CircleX, Info, MessageCircleWarning } from "lucide-react"
import { PropsWithChildren } from "react"

interface Props {
  className?: string
  severity?: "info" | "error"
  color?: string
  size?: "sm" | "md"
}
export const Alert = ({ size = "md", children, className, severity }: PropsWithChildren<Props>) => {
  const iconClass = clsx("flex-shrink-0", { "w-4 h-": size === "sm", "w-5 h-5": size === "md" })
  let Icon = MessageCircleWarning
  if (severity === "info") Icon = Info
  if (severity === "error") Icon = CircleX
  return (
    <div
      className={clsx("p-[15px] flex items-start text-[14px] gap-2.5", className, {
        "bg-[#FCF7D1] text-[#896e39]": !severity,
        "bg-blue-100/70 text-primary": severity === "info",
        "bg-red-100/70 text-red-700": severity === "error",
        "!text-[12px] p-2": size === "sm",
      })}
    >
      <Icon className={iconClass} />
      {children}
    </div>
  )
}
